import React, { Fragment, useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import CollectionSettlementList from "./CollectionSettlementList"
import CollectionPaymentList from "./CollectionPaymentList"
import { getSettlement } from "crud/auth.crud";
import moment from "moment";

import ChartistGraph from 'react-chartist';
import "chartist/dist/scss/chartist.scss";
import loading from "../../assets/images/loading.gif";
import CollectionSettlementTable from "./CollectionSettlementTable";
import CollectionPaymentTable from "./CollectionPaymentTable";
import Modal from "components/RopikCustom/Modal_v2";
import Util from "pages/Dashboard/Common/Util";


const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const SettlementManagementDetails = () => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const location = useLocation()
  const [listCount, setListCount] = useState(0)
  const [settlementState, setSettlementState] = useState('settlement')
  const [labelArr, setLabelArr] = useState([])
  const [isLoading2, setIsLoading2] = useState(false);
  const [qtyArr, setQtyArr] = useState([]);
  const [priceArr, setPriceArr] = useState([]);
  const [payedPriceArr, setPayedPriceArr] = useState([]);
  const [modalShow, setModalShow] = useState({
    edit: false,
  })

  // 그래프 그릴 때 쓰는거
  const makeDataArr = async () => {
    setIsLoading2(true)
    if (labelArr.length === 0) {
      return;
    }
    let arr = [...labelArr]
    let page = 1
    let content = []
    while (true) {
      const params = {
        page: page,
        company: location.state?.company?.id,
        collection_company: selector.auth?.user?.member_group?.[0]?.company_group?.id
      }
      let url = '/summary_waste_collect/data_list/?page=' + params.page + '&company=' + params.company + '&collection_company=' + params.collection_company;

      const response = await getSettlement(url);
      if (response.status === 200) {
        const temporaryData = response.data?.results || [];
        if (temporaryData.length > 0) {
          content = [...content, ...temporaryData]
          if (temporaryData[temporaryData.length - 1].summary_date.substr(2, 2) * 1 < arr[0].substr(0, 2) * 1) {
            break
          } else if (temporaryData[temporaryData.length - 1].summary_date.substr(2, 2) * 1 === arr[0].substr(0, 2) * 1 && temporaryData[temporaryData.length - 1].summary_date.substr(5, 2) * 1 < arr[0].substr(3, 2) * 1) {
            break
          } else {
            page += 1
          }
        } else {
          break
        }
      }
    }
    let arr2 = new Array(arr.length).fill(0);
    let arr3 = new Array(arr.length).fill(0);
    let arr4 = new Array(arr.length).fill(0);
    for (let i = 0; i < content.length; i++) {
      for (let j = 0; j < arr.length; j++) {
        if (`${content[i].summary_date.substr(2, 2)}.${content[i].summary_date.substr(5, 2)}` === arr[j]) {
          arr2[j] += content[i].qty_l
          arr3[j] += content[i].total_price
          arr4[j] += content[i].payed_price
        }
      }
    }
    setQtyArr([...arr2]);
    setPriceArr([...arr3]);
    setPayedPriceArr([...arr4]);
    setIsLoading2(false)
  }

  const makeLabels = () => {
    let arr = []
    arr.length = 14
    for (let i = 1; i <= 14; i++) {
      if (moment(newDate).format("MM") - (i - 1) > 0) {
        arr[14 - i] = `${moment(newDate).format("YY")}.${moment(newDate).format("MM") - (i - 1)}`
      } else if (12 + (moment(newDate).format("MM") - (i - 1)) > 0) {
        arr[14 - i] = `${moment(newDate).format("YY") - 1}.${12 + (moment(newDate).format("MM") - (i - 1))}`
      } else {
        arr[14 - i] = `${moment(newDate).format("YY") - 2}.${24 + (moment(newDate).format("MM") - (i - 1))}`
      }
      if (arr[14 - i].length === 4) {
        arr[14 - i] = arr[14 - i].substr(0, 3) + '0' + arr[14 - i].substr(3, 1)
      }
    }
    setLabelArr([...arr])
  }

  // 그래프 그릴 때 쓰는거
  const lineChartData1 = {
    labels: labelArr,
    series: [qtyArr]
  }
  const lineChartOptions1 = {
    low: 0,
    showArea: true,
    height: '300px'
  }

  const lineChartData2 = {
    labels: labelArr,
    series: [priceArr, payedPriceArr]
  }
  const lineChartOptions2 = {
    low: 0,
    showArea: true,
    height: '300px'
  }
  
  useEffect(()=>{
    makeLabels()
  }, [])

  useEffect(()=>{
    makeDataArr()
  }, [labelArr])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>거래처 정산관리 상세 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="정산관리" breadcrumbItem="거래처 정산관리 상세" />          
          <Row>
            <Col xs='12'>
              <div className="email-rightbar mb-3">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text font-size-12">거래처명</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.company?.name }</td>
                          <td className="w-10 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.company?.company_number }</td>
                          <td className="w-10 padding-left-8 primary-bg white-text font-size-12">수거단위</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.contract?.collect_type }</td>
                          <td className="w-10 padding-left-8 primary-bg white-text font-size-12">기본량</td>
                          <td className="w-15 padding-left-8 font-size-12">{ Util.setCommaPrice((location?.state?.contract?.collect_type == 'l' ? location?.state?.contract?.min_l : location?.state?.contract?.min_kg) || 0) }</td>
                        </tr>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">수거요일</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.contract?.collection_day }</td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">요금제</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.contract?.billing_type == 'P' ? '종량제' : '정액제' }</td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">단가</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.contract?.collect_type == 'l' ? location?.state?.contract?.price_per_l : location?.state?.contract?.price_per_kg_emitter }</td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">기본금액</td>
                          <td className="w-15 padding-left-8 font-size-12">{ location?.state?.contract?.min_price }</td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center mb-2 margin-top-40">
            <button style={{ width: 80, height: 27 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 ${settlementState === 'settlement' ? selectedClass : unselectedClass}`} onClick={() => {
              setSettlementState('settlement')
            }}>
              정산내역
            </button>
            <button style={{ width: 80, height: 27 }} type="button" className={`custom-btn border-radius-0 font-size-11 line-height-1 ${settlementState === 'payment' ? selectedClass : unselectedClass}`} onClick={() => {
              setSettlementState('payment')
            }}>
              고지내역
            </button>
            <p className="mb-0 font-size-16"><span className="font-weight-bold">거래처 정산 목록</span> [ 건수 : {listCount}건 ]</p>
          </div>

          <Row>
            <Col xl={6} lg={12}>
              {settlementState === 'settlement' && <CollectionSettlementTable listCount={listCount} setListCount={setListCount}/>}
              {settlementState === 'payment' && <CollectionPaymentTable listCount={listCount} setListCount={setListCount} />}
            </Col>
            <Col xl={6} lg={12}>
              <Card>
                <CardBody>
                  <Row className="align-items-center mb-4 justify-content-between">
                    <div className="fit-content">
                      <p className="text-dark-gray font-size-16 font-weight-bold mb-0">{location.state?.company?.name} 최근 14개월 금액 차트</p>
                    </div>
                    <div className="fit-content d-flex align-items-center">
                      <div style={{ backgroundColor: '#BF9C46', width: 24, height: 12 }} />
                      <p className="mb-0 padding-left-8 padding-right-16">고지금액</p>
                      <div style={{ backgroundColor: '#488ECE', width: 24, height: 12 }} />
                      <p className="mb-0 padding-left-8">납부금액</p>
                    </div>
                  </Row>
                  <div>
                    <ChartistGraph data={lineChartData2} options={lineChartOptions2} type={'Bar'} />
                  </div>
                </CardBody>
                {isLoading2 && <div style={{
                  position: "absolute",
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  background: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 999,
                  display: "flex",
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img src={loading} alt="로딩중입니다." width={'7%'}></img>
                </div>}
              </Card>
              <Card>
                <CardBody>
                  <Row className="align-items-center mb-4 justify-content-between">
                    <div className="fit-content">
                      <p className="text-dark-gray font-size-16 font-weight-bold mb-0">{location.state?.company?.name} 최근 14개월 수거량 차트</p>
                    </div>
                    <div className="fit-content d-flex align-items-center">
                      <svg width={24} height={12}>
                        <path d="M0,6L24,6" stroke="#BF9C46" strokeWidth="4" fillOpacity="1" fill="none"></path>
                        <circle cx="12" cy="6" r="6" stroke="none" strokeWidth="0" fill="#BF9C46"></circle>
                      </svg>
                      <p className="mb-0 padding-left-8">수거량</p>
                    </div>
                  </Row>
                  <div>
                    <ChartistGraph data={lineChartData1} options={lineChartOptions1} type={'Line'} />
                  </div>
                </CardBody>
                {isLoading2 && <div style={{
                  position: "absolute",
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  background: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 999,
                  display: "flex",
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img src={loading} alt="로딩중입니다." width={'7%'}></img>
                </div>}
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default SettlementManagementDetails
